// extracted by mini-css-extract-plugin
export default {"mainHead":"StepNavigator_mainHead__-gvf6","navigationButtons":"StepNavigator_navigationButtons__laped","spinner":"StepNavigator_spinner__riDr3"};